import classNames from 'classnames';
import * as React from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';
import { NavigationSectionViewModel } from '../NavigationSectionViewModel.csharp';
import { NavListItem } from './NavListItem/NavListItem';

interface NavListProps {
    items: NavigationSectionViewModel[];
    link?: string;
    isParentVisible: boolean;
    onClickOutside: () => void;
    onBack?: () => void;
    setIsSubNavigationOpen?: (value: boolean) => void;
    hideCategoryLink?: boolean;
    isFirstLevel?: boolean;
    additionalItemsName?: string;
    additionalItems?: NavigationSectionViewModel[];
}

export const NavList = (props: NavListProps) => {
    return (
        props.items && (
            <ul className="NavList">
                {props.link && !props.hideCategoryLink && (
                    <li className="NavListItem">
                        <div className={classNames('NavListItem__Heading', props.isFirstLevel && 'NavListItem__Heading--FirstLevel')}>
                            <a href={props.link} className="NavList__Link NavList__Link--Bold">
                                {getTranslation(keys['navigation.seeAllProducts'])}
                            </a>
                        </div>
                    </li>
                )}
                {props.items.map((item) => (
                    <NavListItem
                        key={item.name}
                        item={item}
                        isParentVisible={props.isParentVisible}
                        onClickOutside={props.onClickOutside}
                        setIsSubNavigationOpen={props.setIsSubNavigationOpen}
                        isFirstLevel={props.isFirstLevel}
                    />
                ))}
                {props.additionalItemsName && props.additionalItems && (
                    <>
                        <li className="NavListItem">
                            <div className={classNames('NavListItem__Heading', props.isFirstLevel && 'NavListItem__Heading--FirstLevel')}>
                                <span className="NavList__AdditionalItemsTitle">{props.additionalItemsName}</span>
                            </div>
                        </li>
                        {props.additionalItems.map((item) => (
                            <NavListItem
                                key={item.name}
                                item={item}
                                isParentVisible={props.isParentVisible}
                                onClickOutside={props.onClickOutside}
                                setIsSubNavigationOpen={props.setIsSubNavigationOpen}
                                isFirstLevel={props.isFirstLevel}
                            />
                        ))}
                    </>
                )}
            </ul>
        )
    );
};
